export default {
    set_communicationEmailSettings: (state, payload)=> {
        if(typeof payload.emailUserId!=='undefined') state.emailSettings.emailUserId = payload.emailUserId
    }
}
